import { getAPIFromDomain } from "lib/api";

export const fetchFleetOperators = async () => {
  const api = getAPIFromDomain("accounts");
  const url = "/driver_users/fleet_operator_names";
  const response = await api.get(url);

  return response.data as string[];
};
